<template>
  <div>
    <Card v-if="status !== 'COMPUTING'">
      <div class="container no-preview">
        <button class="slds-button slds-button_neutral" @click.once="computePreview" :disabled="isView">
          {{ $t('campaignDesigner.finalCheckAndCampaignRelease.computePreview') }}
        </button>
      </div>
    </Card>
    <!-- <Card v-if="status === 'COMPUTED'">
      <Input :label="$t('campaignDesigner.finalCheckAndCampaignRelease.channelPriority')" v-model="channelPriority" v-if="isCreate || isEdit" />
      <OutputField :label="$t('campaignDesigner.finalCheckAndCampaignRelease.channelPriority')" :value="channelPriority" v-else />
    </Card> -->
    <Card v-if="['COMPUTING', 'COMPUTED', 'ERROR'].includes(status)" :has-empty-title="status === 'COMPUTED' && !!previewData && !!Object.keys(this.previewData).length">
      <button
        :disabled="loading"
        @click="download"
        class="slds-button slds-button_neutral slds-button_brand"
        slot="actions"
        v-if="status === 'COMPUTED' && previewData && Object.keys(this.previewData).length">

        {{$t('action.downloadAsCsv')}}
      </button>
      <Spinner v-if="loading" />
      <template v-else>
        <div class="container" v-if="status === 'COMPUTING'">
          <span class="slds-text-heading_medium">
            {{ $t('campaignDesigner.finalCheckAndCampaignRelease.computingPreview') }}
          </span>
          <Spinner class="spinner"/>
        </div>
        <div v-else-if="status === 'ERROR'">
          <section class="slds-modal_prompt slds-fade-in-open">
            <div class="slds-modal__container">
              <header class="slds-modal__header slds-theme_error slds-theme_alert-texture">
                <h2 class="slds-text-heading_medium" id="prompt-heading-id">{{$t('campaignDesigner.finalCheckAndCampaignRelease.previewError')}}</h2>
              </header>
              <div class="slds-modal__content slds-p-around_medium" id="prompt-message-wrapper">
                <p>{{previewError.message}}</p>
              </div>
            </div>
          </section>
        </div>
        <div v-else-if="status === 'COMPUTED'" style="display: flex; flex-direction: row;">
          <template v-if="previewData && previewData.length">
            <div style="flex-grow: 1">
              <transition-group name="fade" tag="div" class="chart-container">
                <Card additional-classes="slds-card_boundary slds-m-right--x-large" :title="row.header" v-for="row in charts" :key="row.level">
                  <GChart v-for="(chart, index) in row.charts"
                    type="PieChart"
                    :data="chart.data"
                    :events="chart.events"
                    :key="index"
                    :options="chart.options"
                    :resizeDebounce="500" />
                </Card>
              </transition-group>
              <div class="slds-m-right--x-large">
                <transition name="fade">
                  <table class="slds-table slds-table_cell-buffer slds-table_bordered" v-if="showChannelsTable">
                    <thead>
                      <tr class="slds-line-height_reset">
                        <th class="" scope="col">
                          <div class="slds-truncate">{{$t('campaignDesigner.finalCheckAndCampaignRelease.brand')}}</div>
                        </th>
                        <th class="" scope="col">
                          <div class="slds-truncate">{{$t('campaignDesigner.finalCheckAndCampaignRelease.status')}}</div>
                        </th>
                        <th class="" scope="col">
                          <div class="slds-truncate">{{$t('campaignDesigner.finalCheckAndCampaignRelease.channel')}}</div>
                        </th>
                        <th class="" scope="col">
                          <div class="slds-truncate">{{$t('campaignDesigner.finalCheckAndCampaignRelease.contactCount')}}</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in channelsTable" :key="index">
                        <td>
                          <div class="slds-truncate">{{$t(`brands.${row.brand}`)}}</div>
                        </td>
                        <td>
                          <div class="slds-truncate">{{$t(`churnScore.${row.targetCluster}`)}}</div>
                        </td>
                        <td>
                          <div class="slds-truncate">{{row.availableChannels}}</div>
                        </td>
                        <td>
                          <div class="slds-truncate">{{row.contactCount}}</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </transition>
              </div>
            </div>
            <div style="flex-grow: 1">
              <table class="slds-table slds-table_cell-buffer slds-table_bordered">
                <thead>
                  <tr class="slds-line-height_reset">
                    <th class="" scope="col">
                      <div class="slds-truncate">{{$t('campaignDesigner.finalCheckAndCampaignRelease.brand')}}</div>
                    </th>
                    <th class="" scope="col">
                      <div class="slds-truncate">{{$t('campaignDesigner.finalCheckAndCampaignRelease.status')}}</div>
                    </th>
                    <th class="" scope="col">
                      <div class="slds-truncate">{{$t('campaignDesigner.finalCheckAndCampaignRelease.channel')}}</div>
                    </th>
                    <th class="" scope="col">
                      <div class="slds-truncate">{{$t('campaignDesigner.finalCheckAndCampaignRelease.contactCount')}}</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in previewData" :key="index">
                    <td>
                      <div class="slds-truncate">{{$t(`brands.${row.brand}`)}}</div>
                    </td>
                    <td>
                      <div class="slds-truncate">{{$t(`churnScore.${row.targetCluster}`)}}</div>
                    </td>
                    <td>
                      <div class="slds-truncate">{{row.availableChannels}}</div>
                    </td>
                    <td>
                      <div class="slds-truncate">{{row.contactCount}}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <span class="slds-text-heading_medium" v-else>
            {{ $t('campaignDesigner.finalCheckAndCampaignRelease.emptyPreview') }}
          </span>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import _ from 'lodash'
import { exportAsCsv } from '../../utils/fileUtils'
import { getErrorMessage, keyBy } from '../../utils/utils'
import HasMode from '../../utils/HasMode'
import Card from '../../slds/Card'
import Input from '../../slds/Input'
import OutputField from '../../slds/OutputField'
import Spinner from '../../../components/Spinner'

export default {
  name: 'FinalCheckAndCampaignRelease',
  mixins: [HasMode],
  components: {
    Card,
    Input,
    OutputField,
    Spinner
  },
  props: {
    loading: Boolean,
    mode: String
  },
  computed: {
    status () {
      if (this.previewData && this.jobId && this.computedPreview && Object.keys(this.previewData).length >= 0) {
        return 'COMPUTED'
      }
      if (this.jobId && this.previewError) {
        return 'ERROR'
      }
      if (this.jobId) {
        return 'COMPUTING'
      }
      return 'MISSING'
    }
  },
  data () {
    return {
      campaignId: '',
      channelPriority: '',
      channelsTable: [],
      charts: [],
      computedPreview: false,
      jobId: '',
      keyedPreview: {},
      refreshJobInterval: null,
      previewData: {},
      previewError: undefined,
      selectedBrand: '',
      showChannelsTable: false
    }
  },
  async created () {
    await this.callLoadFromStore()
  },
  methods: {
    addChartsRow (data, level) {
      const charts = data.children.map(child => {
        return {
          data: [
            [child.name, this.$t('campaignDesigner.finalCheckAndCampaignRelease.contactCount')],
            ...child.children.map(c => [c.name, c.value])
          ],
          events: {
            click: (options) => {
              this.charts.length = level + 1
              const index = options.targetID.split('#')[1]
              if (index && child.children[index].children.length) {
                this.showChannelsTable = false
                this.channelsTable = {}
                this.selectedBrand = child.children[index].name
                this.addChartsRow(child.children[index], level + 1)
              } else {
                  const selectedScore = this.charts[1].charts[0].data[parseInt(index) + 1][0] // child.children[index].name
                  this.channelsTable = this.previewData.filter(row => {
                    return this.$t(`brands.${row.brand}`) === this.selectedBrand && this.$t(`churnScore.${row.targetCluster}`) === selectedScore
                  })
                  this.showChannelsTable = true
              }
            }
          },
          options: {
            colors: ['#00448B', '#005FAA', '#4485C6', '#7AB0E0', '#98CAFF', '#D6EAFF'],
            title: child.name,
            pieSliceText: 'label',
            is3D: true,
            width: 550,
            height: 500,
            enableInteractivity: true
          }
        }
      })

      this.charts.push({ level, charts, header: data.name })
    },
    async callLoadFromStore () {
      const campaign = this.loadFromStore('preview')
      this.campaignId = campaign.id
      // if (campaign.preview.preview) {
      //   this.previewData = _.sortBy(campaign.preview.preview, ['brand', 'targetCluster', 'availableChannels'])
      // }
      this.channelPriority = campaign.config.preview.channelPriority
      this.jobId = campaign.config.preview && campaign.config.preview.jobId ? campaign.config.preview.jobId : null

      if (this.jobId) {
        await this.poll()
      }
    },
    async computePreview () {
      try {
        if (this.status === 'COMPUTED') {
          this.$store.dispatch('campaignDesigner/clearPreview')
          await this.callLoadFromStore()
          this.previewData = {}
          this.jobId = null
          this.computedPreview = false
        }
        let functionToCall
        if (this.isCreate) {
          functionToCall = 'save'
        } else {
          functionToCall = 'update'
        }
        this.charts = []
        this.$emit('callFunction', { functionToCall, callback: this.startComputePreview })
      } catch (error) {
        this.showToast('error', this.$t('general.error'), 'text', getErrorMessage(error))
      }
    },
    download () {
      const campaign = this.loadFromStore('preview')
      const cmpd_id = campaign.id
      const mappedPreview = this.previewData
        .map(row => {
          return [
            this.$t(`brands.${row.brand}`),
            this.$t(`churnScore.${row.targetCluster}`),
            row.availableChannels,
            row.contactCount
          ]
        })
      exportAsCsv([[
        this.$t('campaignDesigner.finalCheckAndCampaignRelease.brand'),
        this.$t('campaignDesigner.finalCheckAndCampaignRelease.status'),
        this.$t('campaignDesigner.finalCheckAndCampaignRelease.channel'),
        this.$t('campaignDesigner.finalCheckAndCampaignRelease.contactCount')
      ],
      ...mappedPreview], 'Target_Preview_' + cmpd_id + '.csv')
    },
    getSectionToSave () {
      return {
        config: {
          jobId: this.jobId,
          channelPriority: this.channelPriority
        },
        flat: {
          channelPriority: this.channelPriority
        }
      }
    },
    mapChartTree (list) {
      const root = {
        name: this.$t('campaignDesigner.finalCheckAndCampaignRelease.brand'),
        value: list.length,
        children: []
      }

      const tree = { children: [root] }

      const keyedByBrand = keyBy(list, 'brand')

      Object.keys(keyedByBrand).forEach(brand => {
        const current = keyedByBrand[brand]
        const keyedByStatus = keyBy(current, 'targetCluster')

        const children = []
        let count = 0
        Object.keys(keyedByStatus).forEach(status => {
          count += keyedByStatus[status].reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.contactCount), 0)
          children.push({
            name: this.$t(`churnScore.${status}`),
            value: keyedByStatus[status].reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.contactCount), 0),
            children: []
          })
        })

        const child = {
          name: this.$t(`brands.${brand}`),
          value: current.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.contactCount), 0),
          children: [
            {
              name: this.$t('campaignDesigner.finalCheckAndCampaignRelease.status'),
              value: count,
              children
            }
          ]
        }

        root.children.push(child)
      })

      return tree
    },
    async poll () {
      const response = await this.$store.dispatch('campaignDesigner/checkPreview', { jobId: this.jobId })
      if (response.status === 'Completed') {
        const preview = await this.$store.dispatch('campaignDesigner/getPreview', { campaignId: response.detail.campaignId.toString() })
        this.previewData = _.sortBy(preview.preview, ['brand', 'targetCluster', 'availableChannels'])
        this.charts.length = 0
        this.computedPreview = true
      } else if (response.status === 'Error') {
        this.previewError = response.statusDetail
      }
    },
    async startComputePreview (campaignId) {
      const startPreviewBody = {
        campaignId: this.campaignId || campaignId,
        department: 'AFTER_SALES',
        recordType: 'full'
      }

      const response = await this.$store.dispatch('campaignDesigner/startPreview', startPreviewBody)
      this.jobId = response.id
    },
    async startPreviewPolling () {
      this.refreshJobInterval = setInterval(this.poll, 5000)
    },
    validate () {
      return true
    }
  },
  watch: {
    previewData (data) {
      if (data) {
        const keyedPreview = this.mapChartTree(data)
        this.keyedPreview = keyedPreview
        this.addChartsRow(keyedPreview, 0)
      }
    },
    status (newValue, oldValue) {
      if (newValue === 'COMPUTING') {
        this.startPreviewPolling()
      } else if (newValue === 'COMPUTED') {
        if (this.refreshJobInterval) {
          clearInterval(this.refreshJobInterval)
        }
      }
    }
  },
  beforeDestroy () {
    if (this.refreshJobInterval) {
      clearInterval(this.refreshJobInterval)
    }
  }
}
</script>
<style lang="scss" scoped>
  .chart-container {
    margin-bottom: 10px;
  }
  .container {
    display: flex;
    justify-content: center;
  }
  .spinner {
    margin-top: 20px;
  }
</style>
